/**
 * Догрузка товаров неактивных вкладок в секции «Tab collections».
 *
 * Раньше секция отдавала товары всех вкладок сразу — одна такая весила около
 * 300 KB HTML, из которых посетитель видел четверть. Теперь на сервере
 * рендерится только активная вкладка, остальные приезжают при первом открытии
 * через Section Rendering API.
 *
 * Порядок карточек, лимит и разметку задаёт сервер — здесь только вставка.
 */
(function () {
  'use strict';

  var SECTION = '[data-section-type="product-grid"]';
  var PENDING = '[data-lazy-tab]';
  var SECTION_ID = 'tab-collection-products';

  /**
   * Section Rendering API возвращает секцию, обёрнутую в <div id="shopify-section-…">.
   * Забираем внутренности обёртки, а не её саму, иначе лишний div сломает грид.
   */
  function extractItems(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var wrapper = doc.querySelector('[id^="shopify-section-"]') || doc.body;
    return Array.prototype.slice.call(wrapper.children);
  }

  function load(grid) {
    if (grid.dataset.tabLoading === 'true') return Promise.resolve();

    var url = grid.dataset.tabCollection;
    if (!url) return Promise.resolve();

    grid.dataset.tabLoading = 'true';

    var sep = url.indexOf('?') === -1 ? '?' : '&';

    return fetch(url + sep + 'section_id=' + SECTION_ID)
      .then(function (res) {
        if (!res.ok) throw new Error('tab section HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var items = extractItems(html);
        if (!items.length) throw new Error('tab section: пустой ответ');

        // Секция всегда отдаёт максимум из схемы родителя (12) — настоящий
        // лимит known только здесь, в data-атрибуте.
        var limit = parseInt(grid.dataset.tabLimit, 10);
        if (limit > 0) items = items.slice(0, limit);

        var frag = document.createDocumentFragment();
        items.forEach(function (item) {
          frag.appendChild(item);
        });
        grid.appendChild(frag);

        // Снимаем метку до переинициализации слайдера: он считает слайды,
        // и повторный вход сюда уже не нужен.
        delete grid.dataset.lazyTab;
        delete grid.dataset.tabLoading;

        var slider = grid.closest('grid-slider');
        if (slider) {
          slider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
        }
      })
      .catch(function (err) {
        // Вкладка останется пустой, но страница живая. Метку снимаем, чтобы
        // следующий клик попробовал ещё раз — сеть могла моргнуть.
        delete grid.dataset.tabLoading;
        if (window.console) console.warn('[tab-collections-lazy]', err);
      });
  }

  function loadCurrent(section) {
    var pane = section.querySelector('.tab-content.current');
    if (!pane) return;

    var grid = pane.querySelector(PENDING);
    if (grid) load(grid);
  }

  function init(root) {
    var sections = root.matches && root.matches(SECTION) ? [root] : root.querySelectorAll(SECTION);

    Array.prototype.forEach.call(sections, function (section) {
      // Секций с вкладками на странице несколько, и каждая тянет этот скрипт.
      // Браузер файл кеширует, но выполняет каждый тег — без метки слушатели
      // навесились бы по разу на копию.
      if (section.dataset.lazyTabsBound === 'true') return;
      if (!section.querySelector(PENDING)) return;
      section.dataset.lazyTabsBound = 'true';

      section.addEventListener('theme:tab:change', function () {
        loadCurrent(section);
      });

      // Предзагрузка по наведению: пока человек ведёт курсор к вкладке, товары
      // успевают приехать, и переключение выглядит мгновенным.
      section.querySelectorAll('.tab-link').forEach(function (link) {
        var prime = function () {
          var id = link.dataset.blockId;
          var pane = id && section.querySelector('#tab--' + id);
          var grid = pane && pane.querySelector(PENDING);
          if (grid) load(grid);
        };

        link.addEventListener('mouseenter', prime, { once: true });
        link.addEventListener('focus', prime, { once: true });
      });
    });
  }

  init(document);

  // Редактор темы пересобирает секцию целиком — слушатели на старой разметке
  // умирают вместе с ней.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
